export const ACTION_TYPE = {
	COPY: 'copy',
	VIEW: 'view',
	EDIT: 'edit',
	DELETE: 'delete',
	RECALL: 'recall',
	DRAGDROP: 'dragdrop',
	SENDSMSMAIL: 'sendsmsmail',
	HISTORY: 'history',
}
